const validate = values => {
  const errors = {}

  if (values && values.questionnaire_form?.create?.questions) {
    values.questionnaire_form?.create?.questions.forEach((question, index) => {
      if (!question.question) {
        errors.questionnaire_form = {
          ...errors.questionnaire_form,
          create: {
            ...errors.questionnaire_form?.create,
            questions: {
              ...errors.questionnaire_form?.create?.questions,
              [`${index}`]: {
                ...errors.questionnaire_form?.create?.questions[`${index}`],
                question: "This question is required",
              },
            },
          },
        }
      }
      if (
        question.answers.filter(
          answer => answer?.answer && answer?.answer.trim()
        ).length < 2
      ) {
        errors.questionnaire_form = {
          ...errors.questionnaire_form,
          create: {
            ...errors.questionnaire_form?.create,
            questions: {
              ...errors.questionnaire_form?.create?.questions,
              [`${index}`]: {
                ...errors.questionnaire_form?.create?.questions[`${index}`],
                answers: {
                  _error: "You have to add at least 2 valid answers.",
                },
              },
            },
          },
        }
      }
    })
  }

  if (!values.questionnaire_form?.create?.name) {
    errors.questionnaire_form = {
      ...errors.questionnaire_form,
      create: {
        ...errors.questionnaire_form?.create,
        name: "The name is required!",
      },
    }
  }

  if (values && values.questionnaire_form?.createResult?.results) {
    values.questionnaire_form?.createResult?.results.map((result, index) => {
      if (!result.title) {
        errors.questionnaire_form = {
          ...errors.questionnaire_form,
          createResult: {
            ...errors.questionnaire_form?.createResult,
            results: {
              ...errors.questionnaire_form?.createResult?.results,
              [`${index}`]: {
                ...errors.questionnaire_form?.createResult?.results[`${index}`],
                title: "The title is required!",
              },
            },
          },
        }
      }
      if (parseInt(result.minScore) >= parseInt(result.maxScore)) {
        errors.questionnaire_form = {
          ...errors.questionnaire_form,
          createResult: {
            ...errors.questionnaire_form?.createResult,
            results: {
              ...errors.questionnaire_form?.createResult?.results,
              [`${index}`]: {
                ...errors.questionnaire_form?.createResult?.results[`${index}`],
                maxScore: `The max value should be greater than ${result.minScore}`,
              },
            },
          },
        }
      }
      if (
        index > 0 &&
        parseInt(
          values.questionnaire_form?.createResult?.results[`${index - 1}`]
            .maxScore
        ) >= parseInt(result.minScore)
      ) {
        errors.questionnaire_form = {
          ...errors.questionnaire_form,
          createResult: {
            ...errors.questionnaire_form?.createResult,
            results: {
              ...errors.questionnaire_form?.createResult?.results,
              [`${index}`]: {
                ...errors.questionnaire_form?.createResult?.results[`${index}`],
                minScore: `The min value should be greater than ${
                  values.questionnaire_form?.createResult?.results[
                    `${index - 1}`
                  ].maxScore
                }`,
              },
            },
          },
        }
      }
    })
  }

  if (!values.questionnaire_form?.createResult?.headline) {
    errors.questionnaire_form = {
      ...errors.questionnaire_form,
      createResult: {
        ...errors.questionnaire_form?.createResult,
        headline: "The headline is required!",
      },
    }
  }

  if (!values.questionnaire_form?.createDesign?.submitText) {
    errors.questionnaire_form = {
      ...errors.questionnaire_form,
      createDesign: {
        ...errors.questionnaire_form?.createDesign,
        submitText: "This text is required!",
      },
    }
  }

  return errors
}

export default validate
